(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ezy-reference-player"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('ezr-player'))customElements.define('ezr-player',class extends HTMLElement{
 connectedCallback(){if(this.ready)return;this.ready=true;this.querySelector('button')?.addEventListener('click',()=>{const template=this.querySelector('template');if(!template)return;this.append(template.content.cloneNode(true));this.classList.add('ezr-player--playing');const video=this.querySelector('video');if(video){video.focus();video.play().catch(()=>{})}else this.querySelector('iframe')?.focus()},{once:true})}
});
  } catch(e) { console.error(e); }
})();

})();
